export const METERS_TYPES = {
  LOAD_METERS: "LOAD_METERS",
  SET_METERS: "SET_METERS",
  CLEAR_METERS: "CLEAR_METERS",
  // new facility
  NEW_METER: "NEW_METER",
  SEND_NEW_METER: "SEND_NEW_METER",
  SET_NEW_METER: "SET_NEW_METER",

  EDIT_METER: "EDIT_METER",
  SET_EDITED_METER: "SET_EDITED_METER",
  DELETE_METER: "DELETE_METER",
  HANDLE_METERS_INPUTS: "HANDLE_METERS_INPUTS",
};
